import { ApiError } from '@gorila-shared-ui/components';
import { downloadRequest, getRequest } from './api';
import { publicSpotsUrl, spotsUrl } from './urls/spotsUrls';

export const getSpotsFileKey = async (spotType: string): Promise<{ key?: string; error?: ApiError }> => {
  const response = await getRequest(spotsUrl, { queryParams: { spotType } }, 'text');

  return {
    key: response?.data,
    error: response?.error,
  };
};

export const getSpotsFile = async (key: string): Promise<{ file?: Blob; error?: ApiError }> => {
  const response = await downloadRequest(`public/${key}`);

  return {
    file: response?.data?.file,
    error: response?.error,
  };
};

export const getPublicSpotsFileKey = async (
  shareLinkId: string,
  spotType: string,
): Promise<{ url?: string; error?: ApiError }> => {
  const response = await getRequest(publicSpotsUrl(shareLinkId), { queryParams: { spotType } });

  return {
    url: response?.data?.url,
    error: response?.error,
  };
};
